// extracted by mini-css-extract-plugin
export default {"chatInfo":"ChatInfo_chatInfo__9C3Ht","chatInfo__image":"ChatInfo_chatInfo__image__16EnU","chatInfo__counter":"ChatInfo_chatInfo__counter__ogqO3"};